<script setup>
// *******************************************
// *****                                 *****
// *****  DashBoard.vue：ダッシュボード  *****
// *****  by RFJ R.Komatsu 2026/05/06    *****
// *****  Changed by RFJ 2026/06/09      *****
// *****                                 *****
// *******************************************
import { onMounted, ref } from 'vue'
//import jwt_check from '@/jwt.js';
/*** 意味がないので削除する
const loginTime = new Date()
const LoginTime = () => {
	const options = {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
		hour: '2-digit',
		minute: '2-digit',
		hour12: false // 24時間形式にする
	}
	return loginTime.toLocaleString('ja-JP', options)
		.replace( /(\d+)\/(\d+)\/(\d+), (\d+):(\d+)/, )
}
***/
const section = localStorage.getItem("section")
/***
function onMounted() {
	//alert(jwt_check());
}
***/
</script>

<template>
  <div class="form-container">
	<h1>ダッシュボード</h1>

    <div class="manual">
	  <h2>マニュアル</h2>
	  <div class="header">
		<div v-if="section=='0000'">
		  <a href="/manual/mieloupe/system.pdf" target="_blank">
		  ・システム管理者版</a>
		</div>
		<div v-if="section.endsWith('0')">
		  <a href="/manual/mieloupe/manager.pdf" target="_blank">
		  ・管理者版</a>
		</div>
		<div>
		  <a href="/manual/mieloupe/server.pdf" target="_blank">
		  ・サーバー版</a>
		</div>
		<div v-if="section!='9999'">
		  <a href="/manual/mieloupe/mobile.pdf" target="_blank">
		  ・携帯版</a>
		</div>
      </div>
	</div>

	<div class="update">
      <h2>システム更新情報</h2>
      <div class="update-list">
        <div class="update-item">
          <div class="update-date">2026年5月7日 Ver 1.1.1</div>
          <div class="update-description">
			システムをリリースしました<br>
           ・地図表示で年度切替ができるようにしました<br>
           ・地図表示のアイコンをわかりやすくしました<br>
           ・一覧表示と利用者管理を整理しました<br>
           ・その他、細かなバグFIXを行いました<br>
		  </div>
        </div>
        <div class="update-item">
          <div class="update-date">2026年4月1日 Ver 1.1.0</div>
          <div class="update-description">
			システムをリリースしました<br>
           ・地図にスマートHOKAKUの捕獲データを表示します<br>
           ・地図に鳥獣保護区を表示します<br>
           ・地図にヒートマップを表示します<br>
           ・地図にメッシュを表示します<br>
           ・その他、細かなバグFIXを行いました<br>
          </div>
        </div>
        <div class="update-item">
          <div class="update-date">2025年3月1日 Ver 0.9.0</div>
          <div class="update-description">
			システムを初期リリースしました
		  </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<style scoped>
.manual {
  background-color: white;
  padding: 5px;
  border-radius: 4px;
  margin-bottom: 10px;
}

.update {
  padding: 5px;
  margin-top: 10px;
}

.update-list {
  margin-top: 10px;
}

.update-item {
  display: flex;
  flex-direction: column;
  padding: 15px;
  border-bottom: 1px solid #ddd;
  transition: background-color 0.2s ease;
}

.update-item:not(:last-child) {
  margin-bottom: 10px;
}

.update-date {
  font-weight: bold;
  color: #555;
  font-size: inherit; /* 親要素のフォントサイズを継承 */
}

.update-description {
  margin-top: 5px;
  color: #333;
  line-height: 1.6;
  font-size: inherit; /* 親要素のフォントサイズを継承 */
}

.update-item:hover {
  background-color: #f5f5f5;
  border-radius: 5px;
}
</style>
